import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Tabs, Row } from 'antd'
import { useParams } from 'react-router-dom'
import { isAdmin, isManager, useSession } from 'packages/@slerp/accounts'

const { TabPane } = Tabs

interface MerchantType {
  id: string
  centralized_perorders: boolean
  description?: string
  name: string
  pre_order_delivery: boolean
  pre_order_pickup: boolean
  slug: string
  stores: []
  setting: {
    [key: string]: string | boolean
  }
}

interface SettingsTabsType {
  merchant: MerchantType
}

// To-Do: Rewrite this component, so tabs can work correctly especially the subtabs
const SettingsTabs = ({ merchant }: SettingsTabsType) => {
  const { user } = useSession()
  const { slug } = useParams<{ slug: string }>()
  const location = useLocation()

  const settingsMatch = location.pathname.match(/\/settings\/([^\/]+)/)
  const settingsPath = settingsMatch ? settingsMatch[1] : null

  const canManage = isAdmin(user) || isManager(user)

  return (
    <>
      <Row data-testid='location-settings-tabs' className='_mb-0'>
        {merchant && (
          <Tabs
            type='card'
            defaultActiveKey={`${settingsPath}`}
            className='_mb-8'
          >
            <TabPane
              key={`general`}
              tab={
                <Link
                  to={`/location/${slug}/settings/general/details`}
                  data-testid='location-settings-general'
                >
                  General
                </Link>
              }
            ></TabPane>
            <TabPane
              key={`same-day`}
              tab={
                <Link
                  to={`/location/${slug}/settings/same-day/order-types`}
                  data-testid='location-settings-sameday'
                >
                  Same Day Orders
                </Link>
              }
            ></TabPane>
            <TabPane
              key={`pre-order`}
              tab={
                <Link
                  to={`/location/${slug}/settings/pre-order/cut-off-times`}
                  data-testid='location-settings-preorder'
                >
                  Pre-orders
                </Link>
              }
            ></TabPane>
            <TabPane
              key={`table`}
              tab={
                <Link
                  to={`/location/${slug}/settings/table/details`}
                  data-testid='location-settings-tableorders'
                >
                  Table Orders
                </Link>
              }
            ></TabPane>
            {merchant.setting.franchise_enabled && canManage && (
              <TabPane
                key={`accounts-and-billing`}
                tab={
                  <Link
                    to={`/location/${slug}/settings/accounts-and-billing`}
                    data-testid='location-settings-accounts-and-billing'
                  >
                    Account and Billing
                  </Link>
                }
              ></TabPane>
            )}
          </Tabs>
        )}
      </Row>
    </>
  )
}

export default SettingsTabs
